import React from "react";
import styles from "./Card1.module.scss";

const Card1 = ({ setStage }) => {
  return (
    <div className={styles.container}>
      <form>
        <div className={styles.field}>
          <label>
            Enter email<span>*</span>
          </label>
          <input type="text" />
        </div>
        <button type="button" onClick={() => setStage(1)}>
          Continue
        </button>
      </form>
    </div>
  );
};

export default Card1;
